module.exports = __webpack_public_path__ + "img/voryl.a668b6bf.jpg";